const testimonialItems = [
  {
    id: 'testimonial-001',
    name: '动漫狂热者',
    role: '资深动漫迷',
    content: '樱花动漫是我用过最好的手机动漫门户！界面简洁清爽，番剧更新速度快，分类也很清晰。每天通勤路上必刷，推荐给所有动漫爱好者。',
    avatarUrl: 'https://readdy.ai/api/search-image?query=Cute%20anime%20style%20avatar%20portrait%2C%20soft%20pastel%20colors%2C%20simple%20clean%20background%2C%20chibi%20art%20style%2C%20kawaii%20expression&width=80&height=80&seq=user-avatar-001&orientation=squarish',
  },
  {
    id: 'testimonial-002',
    name: '小林',
    role: '大学生',
    content: '作为动漫社社长，我经常需要查找各种动漫资讯。樱花动漫的文章质量很高，深度分析和新番导览都很有参考价值。',
    avatarUrl: 'https://readdy.ai/api/search-image?query=Cute%20anime%20style%20boy%20avatar%20portrait%2C%20soft%20blue%20and%20white%20colors%2C%20simple%20clean%20background%2C%20chibi%20art%20style%2C%20friendly%20expression&width=80&height=80&seq=user-avatar-002&orientation=squarish',
  },
  {
    id: 'testimonial-003',
    name: '喵帕斯',
    role: '二次元博主',
    content: '手机端优化做得特别好，加载速度快，排版也很舒服。分类筛选功能让我能快速找到想看的番，强烈推荐！',
    avatarUrl: 'https://readdy.ai/api/search-image?query=Cute%20anime%20style%20girl%20avatar%20portrait%2C%20soft%20pink%20colors%2C%20simple%20clean%20background%2C%20chibi%20art%20style%2C%20happy%20expression&width=80&height=80&seq=user-avatar-003&orientation=squarish',
  },
  {
    id: 'testimonial-004',
    name: '星空下的约定',
    role: '上班族动漫迷',
    content: '下班后的治愈时光就是打开樱花动漫看看最新番剧。内容更新及时，不会错过任何一部好番。',
    avatarUrl: 'https://readdy.ai/api/search-image?query=Cute%20anime%20style%20young%20adult%20avatar%20portrait%2C%20soft%20warm%20colors%2C%20simple%20clean%20background%2C%20chibi%20art%20style%2C%20relaxed%20expression&width=80&height=80&seq=user-avatar-004&orientation=squarish',
  },
  {
    id: 'testimonial-005',
    name: '次元旅人',
    role: '自由插画师',
    content: '不仅番剧资源丰富，文章区的深度分析也让我对很多作品有了新的理解。国漫专区更是良心！',
    avatarUrl: 'https://readdy.ai/api/search-image?query=Cute%20anime%20style%20artist%20avatar%20portrait%2C%20soft%20watercolor%20style%2C%20gentle%20colors%2C%20simple%20clean%20background&width=80&height=80&seq=user-avatar-005&orientation=squarish',
  },
];

export default function TestimonialSection() {
  return (
    <section className="w-full bg-background-100 py-14 md:py-20">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-primary-100 mb-4">
            <i className="ri-double-quotes-l text-xl text-primary-500"></i>
          </div>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold font-heading text-foreground-900">
            漫迷<span className="text-primary-500">口碑</span>
          </h2>
          <p className="mt-3 text-sm text-foreground-500">听听动漫爱好者们怎么说</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
          {testimonialItems.slice(0, 2).map((t) => (
            <div
              key={t.id}
              className="bg-background-50 rounded-lg p-5 md:p-6 flex flex-col"
            >
              <div className="flex items-center gap-3 mb-4">
                <img
                  src={t.avatarUrl}
                  alt={t.name}
                  className="w-10 h-10 rounded-full object-cover"
                  loading="lazy"
                />
                <div>
                  <p className="text-sm font-semibold text-foreground-900">{t.name}</p>
                  <p className="text-xs text-foreground-500">{t.role}</p>
                </div>
              </div>
              <i className="ri-double-quotes-l text-2xl text-primary-200 mb-2"></i>
              <p className="text-sm text-foreground-700 leading-relaxed flex-1">{t.content}</p>
            </div>
          ))}

          <div className="relative rounded-lg overflow-hidden aspect-[3/4] md:aspect-auto">
            <img
              src="https://readdy.ai/api/search-image?query=Happy%20anime%20fan%20watching%20on%20smartphone%20in%20cozy%20cafe%2C%20warm%20ambient%20lighting%2C%20candid%20lifestyle%20photography%2C%20soft%20bokeh%20background%2C%20natural%20expression%2C%20Japanese%20aesthetic&width=600&height=800&seq=testimonial-photo-01&orientation=portrait"
              alt="动漫爱好者"
              className="w-full h-full object-cover"
              loading="lazy"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
            <div className="absolute bottom-0 left-0 right-0 p-5">
              <p className="text-sm font-semibold text-background-50">{testimonialItems[2].name}</p>
              <p className="text-xs text-background-300">{testimonialItems[2].role}</p>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5 mt-4 md:mt-5">
          <div className="relative rounded-lg overflow-hidden aspect-[16/9] md:col-span-2">
            <img
              src="https://readdy.ai/api/search-image?query=Cozy%20anime%20watching%20setup%20with%20laptop%20and%20headphones%2C%20warm%20desk%20lamp%20lighting%2C%20anime%20posters%20on%20wall%2C%20comfortable%20room%20atmosphere%2C%20lifestyle%20photography%2C%20soft%20warm%20tones&width=900&height=500&seq=testimonial-wide-01&orientation=landscape"
              alt="动漫爱好者桌面"
              className="w-full h-full object-cover"
              loading="lazy"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-black/60 to-transparent"></div>
            <div className="absolute bottom-0 left-0 p-5">
              <p className="text-sm font-semibold text-background-50">{testimonialItems[3].name}</p>
              <p className="text-xs text-background-300">{testimonialItems[3].role}</p>
              <p className="mt-1 text-xs text-background-200 max-w-sm">{testimonialItems[3].content}</p>
            </div>
          </div>

          <div className="flex flex-col gap-4">
            <div className="bg-background-50 rounded-lg p-5 flex-1">
              <i className="ri-double-quotes-l text-2xl text-primary-200 mb-2"></i>
              <p className="text-sm text-foreground-700 leading-relaxed mb-3">{testimonialItems[4].content}</p>
              <div className="flex items-center gap-3">
                <img
                  src={testimonialItems[4].avatarUrl}
                  alt={testimonialItems[4].name}
                  className="w-9 h-9 rounded-full object-cover"
                  loading="lazy"
                />
                <div>
                  <p className="text-sm font-semibold text-foreground-900">{testimonialItems[4].name}</p>
                  <p className="text-xs text-foreground-500">{testimonialItems[4].role}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}